import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @qcx/no-invalid-filename */
import { forwardRef } from 'react';
export const wrapWithDefaultProps = (Component, defaultProps) => {
    const result = forwardRef((props, ref) => {
        const mergedProps = { ...defaultProps, ...props };
        // @ts-ignore
        return _jsx(Component, { ref: ref, ...mergedProps });
    });
    // @ts-ignore
    result.displayName = Component.displayName;
    return result;
};
